import React from 'react';

import Checkbox from '../../common/Checkbox';
import { useFeatureFlagOverridesApi, useFeatureFlags } from '../../../modules/infra/feature-flags';

const FeatureFlagOverrides = () => {
  const flags = useFeatureFlags();
  const {
    overrides,
    setOverride,
    resetOverride,
    resetOverrides,
    originalFlags,
  } = useFeatureFlagOverridesApi();

  const isFlagOverridden = flagName => flagName in overrides;

  return (
    <div className="layout u-mt+ u-pl">
      <div className="layout__item u-pl c-heading c-heading--dark">Feature Flag overrides</div>

      <div className="layout__item u-pl">
        {Object.keys(flags).map(flagName => (
          <div className="o-flexbox o-flexbox--content-align-center o-flexbox--justify-start" key={flagName}>
            <Checkbox
              className="u-mv-"
              checked={flags[flagName] === true}
              label={flagName}
              onChange={() => setOverride(flagName, !flags[flagName])}
            />
            <span>original value: {originalFlags[flagName].toString()}</span>
            <button
              className="c-btn c-btn--small u-ml-"
              display-if={isFlagOverridden(flagName)}
              onClick={() => resetOverride(flagName)}
            >
              Remove override
            </button>
          </div>
        ))}

        <button
          className="c-btn u-mt-"
          display-if={Object.keys(overrides).length > 0}
          onClick={resetOverrides}
        >
          Remove all overrides
        </button>
      </div>
      <div className="layout__item c-separator u-mt" />
    </div>
  );
};

export default FeatureFlagOverrides;
